export default function getResource(label, vars = []) {
    const resources = {
        allRewards: 'Toutes les récompenses',
        addFullSize: 'Ajouter le produit en format standard',
        rougeBadge: 'ROUGE',
        freeShipping: 'Profitez de l’expédition GRATUITE pour plus de 750 récompenses, aucun achat requis',
        '50 Points': '50 Points',
        '100 Points': '100 Points',
        '250-499 Points': 'Plus de 250 Points',
        '500-749 Points': 'Plus de 500 Points',
        '750-2999 Points': 'Plus de 750 Points',
        '3000-4999 Points': 'Plus de 3 000 Points',
        '5000-19999 Points': 'Plus de 5 000 Points',
        '20000+ Points': 'Plus de 20 000 Points'
    };
    return resources[label];
}
